import axios from 'axios';


const api = axios.create({
    baseURL: process.env.REACT_APP_CAMPAINGS_API_URL || 'https://api.donaciones.comidaparatodos.org',
    timeout: 10000,
    headers: { 
        'Content-Type': 'application/json', 
        "x-api-key": process.env.REACT_APP_CAMPAINGS_API_KEY || '2019fgs2025' 
    }
});

export default class CampaingsAPI {
    static getCampaings() {
        return new Promise((resolve, reject) => {
            api.get(`/campaing`)
                .then(res => {
                    resolve(res.data?.data || [])
                })
                .catch(err => reject(err))
        });
    }

    static getCampaingById(id) {
        return new Promise((resolve, reject) => {
            api.get(`/campaing/${id}`)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => reject(err))
        });
    }

    static createCampaing(data) {
        return new Promise((resolve, reject) => {
            api.post("/campaing", data, { headers: { "Content-Type": "multipart/form-data" } })
                .then(res => resolve(res.data))
                .catch(err => reject(err));
        });
    }

    static updateCampaing(id, data) {
        return new Promise((resolve, reject) => {
            api.put(`/campaing/${id}`, data, { headers: { "Content-Type": "multipart/form-data" } })
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => reject(err))
        });
    }

    static deleteCampaingById(id) {
        return new Promise((resolve, reject) => {
            api.delete(`/campaing/${id}`)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => reject(err))
        });
    }

    static getDonations() {
        return new Promise((resolve, reject) => {
            api.get(`/donation`)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => reject(err))
        });
    }

    static getCountries() {
        return new Promise((resolve, reject) => {
            api.get(`/country`)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => reject(err))
        });
    }
} 